import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { Icon, luxColors, Iffy, DNABox, DNAText } from '@alucio/lux-ui';
// TODO refactor /w DNA Modal screen when it's ready
const styles = StyleSheet.create({
    icon: {
        color: luxColors.closeIcon.primary,
        height: 24,
        width: 24,
    },
    modalHeader: {
        paddingBottom: 16,
    },
    modalHeaderText: {
        color: luxColors.info.primary,
    },
    modalContentWrapper: {
        paddingBottom: 24,
        paddingRight: 24,
    },
    modalSection: {
        borderBottomColor: luxColors.contentPanelBackground.tertiary,
        borderBottomWidth: 1,
        paddingLeft: 24,
        paddingRight: 24,
    },
    modalWrapper: {
        backgroundColor: luxColors.contentPanelBackground.primary,
        borderRadius: 4,
        paddingTop: 16,
    },
});
export default function VirtualModal(props) {
    const { headerText, children, onClose, showCloseButton = true, width } = props;
    const modalStyle = StyleSheet.create({
        modalStyle: {
            width: width,
        },
    });
    return (React.createElement(DNABox, { appearance: "col", style: [styles.modalWrapper, modalStyle.modalStyle] },
        React.createElement(DNABox, { appearance: "row", spacing: "between", style: [styles.modalSection, styles.modalHeader] },
            React.createElement(DNAText, { h5: true, style: styles.modalHeaderText }, headerText),
            React.createElement(Iffy, { is: showCloseButton },
                React.createElement(TouchableOpacity, { onPress: onClose },
                    React.createElement(Icon, { style: styles.icon, name: "close" })))),
        React.createElement(DNABox, { style: [styles.modalSection, styles.modalContentWrapper] }, children)));
}
//# sourceMappingURL=VirtualModal.js.map